import api from '@/apis/di/topicEstimateAPI.js';
import Crud from '@/stores/crudBaseCache.js';

var crud = new Crud('topicEstimate', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_topic_estimate',
    field: {
      key: 'topic_estimate_id',
      code: 'budget_item_code',
    },
    defaultSort: 'budget_item_code',
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
